import { Dispatch, SetStateAction } from 'react'
import { IEjercicioItems } from '../../Interfaces/IMisRutinas';
import { Dialog,  DialogContent, DialogTitle, useMediaQuery } from '@mui/material'

import VideoPlayer from '../VideoPlayer/VideoPlayer';
import arrowBack from '../../Shared/Images/atras-icon.png';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  ejercicio: IEjercicioItems;
  reemplazo?: boolean;
};

const ModalVerticalVideo = ({ isOpen, setIsOpen, ejercicio, reemplazo = false }: Props) => {
  
  const isMobile = useMediaQuery('(max-width: 650px)');

  return (
    <div className="">
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
      <DialogTitle sx={{ backgroundColor: 'white', fontWeight: '700'  }}>          
        <div className='flex flex-row gap-3'>

          <img
            src={arrowBack}
            height={20}
            className="h-[20px] cursor-pointer self-start"
            onClick={() => setIsOpen(false) }
          />

          <p className='text-lg mb-0'> { ejercicio.ejercicio } </p>

        </div>
      </DialogTitle>
      <DialogContent dividers>

        <div className={ isMobile ? '' : 'pb-7 px-10' }>
          <VideoPlayer 
            url={ reemplazo ? ejercicio.ejercicioReemplazoURL : ejercicio.ejercicioURL }
            autoplay={true}
          />
        </div>
        
      </DialogContent>
    </Dialog>
    </div>
  )
}

export default ModalVerticalVideo;
